import { Component, Input, OnInit } from '@angular/core';
import {
  CaseBehaviour,
  ManageStudentDrawerParams,
} from '../../../../insights.interface';
import { CommonModule } from '@angular/common';
import { NzTableModule } from 'ng-zorro-antd/table';
import { NzRadioModule, NzRadioGroupComponent } from 'ng-zorro-antd/radio';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { FormsModule } from '@angular/forms';
import { DrawerService } from '../../../../../../core/services/drawer.service';
import { DRAWER_IDS } from '../../../../../../core/constants/drawer-ids.constant';
import { Subject, takeUntil } from 'rxjs';
import { InsightMode } from '../../../../insights.enums';
import { DataSheetComponent } from './data-sheet/data-sheet.component';
import { ManageDataDrawerParams } from '../../../insights-data/insights-data.interface';
import { NzFormModule } from 'ng-zorro-antd/form';
import { UserDatePipe } from '../../../../../../shared/pipes/user-date.pipe';
@Component({
  selector: 'app-behavior-category-data',
  standalone: true,
  imports: [
    CommonModule,
    NzRadioModule,
    NzTableModule,
    NzButtonModule,
    FormsModule,
    NzRadioGroupComponent,
    DataSheetComponent,
    NzFormModule,
    UserDatePipe,
  ],
  templateUrl: './behavior-category-data.component.html',
  styleUrl: './behavior-category-data.component.scss',
})
export class BehaviorCategoryDataComponent implements OnInit {
  @Input() categoryData!: CaseBehaviour[];
  selectedBehvaior = {} as CaseBehaviour;
  private destroy$ = new Subject<void>();
  caseParams: ManageStudentDrawerParams = {} as ManageStudentDrawerParams;
  dataSheetParams: ManageDataDrawerParams | null = null;
  isDataSheet = false;

  constructor(private drawerService: DrawerService) {
    this.setupDrawerSubscription();
  }

  ngOnInit(): void {
    if (this.categoryData) {
      if (this.caseParams) {
        if (this.categoryData?.length === 1) {
          this.selectedBehvaior = this.categoryData[0];
          this.goToNext();
        }
      }
    }
  }
  getSubcategory(data: CaseBehaviour) {
    const behaviorCatories =
      data.behaviorCategoryTypes.map(bt => bt.behaviorTypeName).join(', ') ||
      'N/A';
    return behaviorCatories;
  }
  private setupDrawerSubscription(): void {
    this.drawerService
      .getParams<ManageStudentDrawerParams>(DRAWER_IDS.ADD_DATA)
      .pipe(takeUntil(this.destroy$))
      .subscribe(params => {
        if (params) {
          this.caseParams = params;
        }
      });
  }
  goToNext() {
    this.isDataSheet = true;
    this.dataSheetParams = {
      case: this.caseParams.case,
      behavior: this.selectedBehvaior,
      mode: InsightMode.VIEW,
      orgId: this.caseParams?.case?.student.organizationId,
      caseBehaviorId: this.selectedBehvaior.id,
    };
  }

  onCancel() {
    this.drawerService.closeDrawer(DRAWER_IDS.ADD_DATA);
  }
  onBack() {
    this.isDataSheet = false;
    this.dataSheetParams = null;
  }
}
